export const LineChartConfig = (series, legendaEnabled, chartBackgroundColor) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
    useGrouping: false,
  });

  return {
    chart: {
      type: 'area',
      backgroundColor: chartBackgroundColor,
      zooming: {
        key: 'alt',
        type: 'x',
      },
      panning: {
        enabled: true,
        type: 'x',
      },
    },
    title: {
      text: '',
    },
    legend: {
      enabled: legendaEnabled,
    },
    xAxis: {
      gridLineWidth: 1,
      crosshair: {
        color: 'red',
        width: 3,
      },
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%e. %b',
        month: "%b '%y",
      },
    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        formatter: function () {
          return `${Highcharts.numberFormat(this.value, 0)} €`;
        },
      },
      tickPositioner: function () {
        let tick = Math.floor(this.dataMin);
        const positions = [],
          increment = Math.ceil((this.dataMax - this.dataMin) / 6);

        if (this.dataMax !== null && this.dataMin !== null) {
          for (tick; tick - increment <= this.dataMax; tick += increment) {
            positions.push(tick);
          }
        }
        return positions;
      },
      maxPadding: 0.01,
    },
    tooltip: {
      style: {
        fontSize: '1em',
      },
      xDateFormat: '%B %e, %Y',
      pointFormatter: function () {
        return `<b>${numberFormatter.format(this.y)} €</b>`;
      },
    },
    plotOptions: {
      area: {
        lineWidth: 4,
        marker: {
          enabled: false,
          symbol: 'circle',
          fillColor: 'red',
          lineColor: 'red',
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: series.map((serie) => ({
      name: serie.name,
      data: serie.data,
      custom: {
        dataHeaders: serie.headers,
      },
      lineColor: serie.lineColor,
      fillColor: {
        linearGradient: [0, 0, 0, 300],
        stops: [
          [0, serie.fillColor],
          [
            1,
            `color-mix(
                        in srgb, ${serie.fillColor} 1%, transparent
                    )`,
          ],
        ],
      },
    })),
    credits: {
      enabled: false,
    },
  };
};
